export const NAVIGATION_ACTIONS = {
  RESET_INVENTORY_FILTERS: 'resetInventoryFilters',
  CLEAR_BLOGS: 'clearBlogs',
  LOGOUT: 'logout',
};

export const DROPDOWN_NAMES = {
  COMPANY: 'company',
  ACCOUNT: 'account',
};

export const primaryNavigationItems = ({ isLoggedIn }) => [
  { label: 'Home', to: '/', action: NAVIGATION_ACTIONS.RESET_INVENTORY_FILTERS },
  {
    label: 'Company',
    dropdownName: DROPDOWN_NAMES.COMPANY,
    children: [
      { label: 'About', to: '/about' },
      { label: 'Meet Our Team', to: '/meet-our-team' },
      { label: 'Blog', to: '/blog', action: NAVIGATION_ACTIONS.CLEAR_BLOGS },
      { label: 'Contacts', to: '/contacts' },
    ],
  },
  { label: 'Auctions', to: '/sales' },
  { label: 'Inventory', to: '/inventory' },
  { label: 'Buy Now', to: '/buyNow' },
  { label: 'Sell Your Asset', to: '/sell' },
  { label: 'Locations', to: '/locations' },
  ...(isLoggedIn ? [] : [{ label: 'Login', to: '/login' }]),
];

export const accountNavigationItems = [
  { label: 'Profile', to: '/account/profile' },
  { label: 'Billing', to: '/account/billing' },
  { label: 'Watch List', to: '/inventory/watch' },
  { label: 'Password', to: '/account/password' },
  { label: 'Logout', to: '/', action: NAVIGATION_ACTIONS.LOGOUT },
];

export const REGISTER_BUTTON_LABEL = 'Register To Bid In Next Auction';
export const REGISTER_BUTTON_SHORT_LABEL = 'Register To Bid';
